import React from "react";
import PropTypes from "prop-types";

const ImageChannelItem = (props) => {

    function getImage(id){
        let list = props.images;
        if (!list) return "";

        for (const item of list) {
            if (item.id === id) {
              return item.url
            }
        }
    }

    let images = null;
    if (props.entry && props.entry.images && typeof props.entry.images  === "object") {//filter value "null"
        if (props.entry.images instanceof Array) {
            images = props.entry.images.map((image, index) => (
                <img key={`image-${index}`} src={getImage(image.id)} className="img-thumbnail mb-2" alt=""></img>
            ));
        } else {
            images = <img id="image-0" src={getImage(props.entry.images.id)} className="img-thumbnail mb-2" alt=""></img>
        }
    }

    return (<div>{images}</div>);
}

ImageChannelItem.propTypes = {
    entry: PropTypes.object
}

export default ImageChannelItem;